const state = {
  userInfo: {
    isUrl: true
    // beanId: "2519742894636277851",
    // accessToken: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJqd3RfdHlwZSI6MSwiand0VHlwZSI6MSwia2V5IjoiYmVhbi1hcHAtdXNlci1rZXkiLCJzc29JZCI6IlU3MDc2ODMzOTIwMTkyMzQ4MTYiLCJiZWFuSWQiOiIyNTE5NzQyODk0NjM2Mjc3ODUxIiwiaWF0IjoxNzA4NTA0MzU3LCJpc3MiOiJnd3QgU2VydmVyIiwicm9sZUNvZGUiOiJhZG1pbiIsImd3SWQiOiIyNTE5NzQyODk0NjM2Mjc3ODUxIiwiZXhwIjoxNzA5MTA5MTU3LCJjaGFubmVsIjoiMSIsImd3bUJyYW5kIjoiQ0NIMDAxIiwiZ3dtUnMiOiIyIn0.AM1hajBrKOrIhAqlxvjVX4FZr8YHVEZf0k091AEkhMGJv-K2Fvvi2yyAgjltBlRoRjSTiA4E2noEwrEYRO0cEraMpHEU-N0q34wdSzBZ_euTVqEUP-5kODySDTkW1udd0ba3YX1nQrW67zgGs-TnrpYkmAYHo0nBDJXtShm4g6uh726Rau1l-skOxjiu64Kd7schrJQyJ8uGl8xSnuc-3RhJyhWfHGZ8RNvWR6lGCxjg0S9__CN4YUSkHpg2jfTvc1w2Hnq4ek3Opx-zD5VkvILqHjMbiTfXxl_jpwxl52tWbdwkXuB8GWmCwdPdk51vRAqmvnv2Tw6TtAjqj8QTaFIaEtNLyI0"
  },
  queryData: {
    activityId: "",
    postId: ""
  },
  qwUserInfo: {}
};

// mutations
const mutations = {
  setQueryData(state, params) {
    state.queryData = params;
  },
  setUserData(state, params) {
    state.userInfo = params;
  },
  setQwUserInfo(state, params) {
    state.qwUserInfo = params;
  }
};

// actions
const actions = {};

export default {
  state,
  actions,
  mutations
};
